<template>
    <router-link to="/">
        <div :class="classes">
            <img style="width: 120px; height: 39px;" :src="url" alt="lukoil logo">
            <div v-if="!isBitumMaterials" class="logo__text">
                {{ $t("академия") }}
            </div>
        </div>
    </router-link>
</template>

<script>
import {mapGetters} from 'vuex';
import REGION_CODES from '@/configs/region_codes';

export default {
  name : 'Logo',
  props: {
    classes_added: {
      type: String,
    },
    url: {
      type    : String,
      required: true,
    },
  },
  data() {
    return {
      isBitumMaterials: false,
    };
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    classes() {
      return 'logo ' + this.classes_added;
    },
  },
  mounted() {
    this.isBitumMaterials = this.user.region_code === REGION_CODES.BITUM_MATERIALS;
  },
};
</script>
